import 'regenerator-runtime/runtime.js'
import 'whatwg-fetch'
import { fetchJsonLd } from '@api-platform/api-doc-parser'

export default async (url, options = {}) => {
    const requestHeaders = new Headers()

    if (options.headers) {
        for (const [key, val] of Object.entries(options.headers)) {
            requestHeaders.set(key, val)
        }
    }

    if (options.user && options.user.authenticated && options.user.token) {
        requestHeaders.set('Authorization', 'Bearer ' + localStorage.getItem('token'))
    }

    const { response, body } = await fetchJsonLd(url, {
        ...options,
        headers: requestHeaders,
    })

    const status = response.status

    if (status >= 200 && status < 300) {
        return Promise.resolve({
            status: status,
            headers: response.headers,
            json: body,
        })
    } else {
        var error = new Error(response.statusText || response.status)
        error.response = response
        error.body = body
        return Promise.reject(error)
    }
}
